// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3119":"installer/css/style","8252":"css/app"}[chunkId] + ".css";
};